import React, { useRef } from "react";
import styled from "styled-components";
import { Interaction, ReactionOverlay } from "components";

const Livestream = () => {
  const livestreamRef = useRef(null);
  return (
    <Container>
      <Stream id="livestream" ref={livestreamRef}>
        <iframe
          src="https://player.vimeo.com/video/1186900537?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
          width="640"
          height="360"
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          title="Video"
        ></iframe>
        {/* <ReactionOverlay livestreamRef={livestreamRef} /> */}
      </Stream>
      {/* <Interaction /> */}
    </Container>
  );
};

const Stream = styled.div`
  position: relative;
  width: 100%;
  transition-duration: 0.75s;
  padding-bottom: 56.25%;
  background: #000;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.25);
  border: 3px solid var(--abbvie-green);
  iframe, img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  @media (min-width: 1150px) {
    grid-column: 1/4;
  }
`;

const Container = styled.main`
  max-width: 1440px;
  margin: 0 auto;
  display: grid;
  grid-gap: 1rem;
  grid-template-columns: 1fr;
  width: 98%;
  margin-top: 3rem;
  @media (min-width: 1150px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
`;

export default Livestream;
